import PageTitle from "~/library/PageTitle"
import LoadingWrapper from "~/library/LoadingWrapper"
import CatchCard from "~/library/CatchCard"
import CatchTable from "~/library/CatchTable"
import Pagination from "~/library/Pagination"
import NavigationLink from "~/library/NavigationLink"

import getAppConfig from "~/utils/getAppConfig"
import useFetchResource from "~/hooks/useFetchResource"
import { apiMenus } from "~/routes"
import Menu from "~/types/Menu"

const MenusList = () => {
  const { venueSlug } = getAppConfig()
  const sortingParams = { "q[s]": "created_at desc" }

  const {
    data: menus,
    refetch,
    metadata,
    isLoading,
  } = useFetchResource<{ menus: Menu[] }, "menus">(apiMenus.index.path({ venueSlug }), "menus", {
    page: "1",
    ...sortingParams,
  })

  const handlePageChange = (page: string) => {
    refetch({ page: page, ...sortingParams })
  }

  return (
    <LoadingWrapper isLoading={isLoading}>
      <PageTitle title="Menus" newItemPath="/menus/new" />

      <div className="row">
        <div className="col-12">
          <CatchCard className={"card-dark-theme"}>
            <CatchTable
              data={menus}
              emptyMessage="No Menus"
              columns={[
                {
                  key: "name",
                  header: "Name",
                  formatter: (name, data) => (
                    <NavigationLink type="menus" to={`/menus/${data.id}`}>
                      {name}
                    </NavigationLink>
                  ),
                },
                {
                  key: "active",
                  header: "Status",
                  formatter: (active) => (
                    <span className={`badge badge-lg ${active ? "bg-success" : "bg-secondary"}`}>
                      {active ? "Active" : "Inactive"}
                    </span>
                  ),
                },
              ]}
            />
            {metadata && (
              <Pagination
                metadata={metadata}
                onPageChange={(page: number) => handlePageChange(page.toString())}
              />
            )}
          </CatchCard>
        </div>
      </div>
    </LoadingWrapper>
  )
}

export default MenusList
